import { IconSvg, IconSvgProps } from "./icon"

export default function Filter(props: IconSvgProps) {
  return (
    <IconSvg {...props}>
      <path d="M7 9.242h5.79" />
      <circle cx="14.93" cy="8.93" r="1.93" />
      <path d="M10.851 15.043h5.786" />
      <circle cx="8.93" cy="14.93" r="1.93" />
    </IconSvg>
  )
}
